<!-- 
The system toolbar.
-->
<template>
  <v-toolbar 
    :clipped-left="$vuetify.breakpoint.smAndUp" color="secondary" dark fixed 
    app class="main-toolbar"
  >
    <v-toolbar-side-icon @click.stop="$emit('update:drawer', !drawer)"/>
    <v-toolbar-title class="hidden-sm-and-down">
      <span class="heading mr-5 ">LTPS Administration <span class="subheading">{{ environment }}</span></span>
    </v-toolbar-title>
    <v-toolbar-title class="hidden-md-and-up ml-1">
      <span class="heading">LTPS <span class="subheading">{{ environment }}</span></span>
    </v-toolbar-title>
    <div id="skipNavigation">
      <div>
        <a href="#" tabindex="1" @click.stop.prevent="skipToContent">Skip to main content</a>
      </div>
    </div>
    <v-spacer/>
    <testing-tools-toolbar-button />
    <sign-in-or-out-toolbar-button />
  </v-toolbar>
</template>

<script>
import * as systemAction from "@/store/system/action-types";
import SignInOrOutToolbarButton from "@/components/system/SignInOrOutToolbarButton.vue";
import TestingToolsToolbarButton from "@/components/system/TestingToolsToolbarButton.vue";

export default {
  components: { SignInOrOutToolbarButton, TestingToolsToolbarButton },
  props: {
    drawer: {
      required: false,
      default: false,
      validator: prop => typeof prop === "boolean" || prop === null
    },
    skipTo: {
      type: HTMLDivElement,
      default: null
    }
  },
  computed: {
    environment() {
      return this.$store.getters.environmentForToolbar;
    },
    mini() {
      return this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.sm;
    },
    large() {
      return this.$vuetify.breakpoint.lgAndUp;
    }
  },
  watch: {
    mini(nowMini) {
      if (nowMini) {
        this.$emit("update:drawer", false);
      }
    },
    large(nowLarge) {
      if (nowLarge) {
        this.$emit("update:drawer", true);
      }
    }
  },
  created() {
    this.$store.dispatch(systemAction.SYSTEM_DETAILS_REFRESH);
  },
  methods: {
    skipToContent() {
      // eslint-disable-next-line
      this.skipTo.tabIndex = "-1";
      this.skipTo.focus();
    }
  }
};
</script>
